import analytics from "web/script/analytics/analytics";
import baustein from "baustein";
import SavedSearchEditOverlay from "web/script/components/overlays/saved-search-edit";

export const EDIT_BUTTON_SELECTOR = ".saved-search-edit__button";

export default baustein.register("saved-search-edit", {
    defaultOptions: {
        savedLystFilterId: null,
    },

    setupEvents(add) {
        add("click", EDIT_BUTTON_SELECTOR, this._onEditClick);
    },

    _onEditClick(event) {
        event.preventDefault();

        const savedLystFilterId = this.options.savedLystFilterId;
        const savedSearchEditOverlay = new SavedSearchEditOverlay({ savedLystFilterId });

        savedSearchEditOverlay.appendTo(document.body);
        savedSearchEditOverlay.open();
        analytics.event("edit", "clicked");
    },
});
